import { Table } from "@/features/Table";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import { useLocation } from "react-router";
import { type S1Position, s1_positions_columns } from "./columns";
import { type FilterS1PositionsSchema, FilterS1Positions } from "./filter";

export const S1PositionsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<S1Position, FilterS1PositionsSchema>
      label="S1 Positions"
      client={Clients.S1_QUANTILIA}
      table_name={Tables.S1_POSITIONS}
      columns={s1_positions_columns}
      filter={<FilterS1Positions />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
